import "core-js/modules/es.array.push.js";
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    isLink: {
      // 是否可跳转
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(item) {
      if (this.isLink) {
        this.$router.push(item.url);
      }
    }
  }
};